import PageLayout from "@/components/PageLayout";

const Privacy = () => (
  <PageLayout
    title="Privacyverklaring"
    metaDescription="Privacyverklaring van Magic Print. Lees hoe wij omgaan met uw persoonlijke gegevens."
  >
    <h1 className="text-3xl md:text-5xl font-bold mb-6">
      Privacyverklaring
    </h1>

    <div className="prose prose-lg max-w-none text-muted-foreground">
      <p>
        Magic Print hecht waarde aan de privacy van alle gebruikers van magicprint.nl en zorgt ervoor dat de persoonlijke informatie die je aan ons verschaft vertrouwelijk wordt behandeld. Op deze pagina laten wij je weten welke gegevens we verzamelen als je onze website gebruikt, waarom we deze gegevens verzamelen en hoe we hiermee jouw gebruikerservaring verbeteren.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-4 text-foreground">Formulieren</h2>
      <p>
        Via onze website kun je een offerte aanvragen via ons offerte formulier. Deze gegevens delen wij niet met derden.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-4 text-foreground">Surfgedrag en statistieken</h2>
      <p>
        Op onze website worden bezoeken bijgehouden. Deze gegevens gebruiken wij voor het analyseren van de bezoekersaantallen en voor het in kaart brengen van de zoekvoorkeuren van onze bezoekers.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-4 text-foreground">Google Analytics</h2>
      <p>
        Via onze website wordt een cookie geplaatst van het Amerikaanse bedrijf Google, als deel van de "Analytics"-dienst. Wij maken gebruik van Google Analytics om het surfgedrag op onze website te analyseren en hiermee de website te verbeteren. De verkregen informatie, inclusief het adres van jouw computer (IP adres) wordt door Google opgeslagen. Voor meer informatie lees het{" "}
        <a href="https://www.google.com/policies/technologies/ads/" target="_blank" rel="noopener noreferrer" className="text-primary underline">privacybeleid van Google</a>.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-4 text-foreground">Overig</h2>
      <p>
        Magic Print zal jouw persoonlijke gegevens niet aan derden verkopen en zal deze uitsluitend aan derden ter beschikking stellen die zijn betrokken bij het uitvoeren van jouw bestelling of verzoek.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-4 text-foreground">Inzien/veranderen persoonsgegevens</h2>
      <p>
        Wij bieden alle bezoekers de mogelijkheid tot het inzien, veranderen of verwijderen van alle persoonlijke informatie die aan ons is verstrekt. Je kunt hiervoor contact met ons opnemen.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-4 text-foreground">Wijzigingen</h2>
      <p>
        Deze privacyverklaring kan worden gewijzigd. Wijzigingen worden bekend gemaakt op deze pagina.
      </p>

      <div className="mt-8 p-6 rounded-xl bg-card border border-border">
        <p className="font-bold text-foreground">Magic Print</p>
        <p>Platinaweg 25</p>
        <p>2544 EZ Den Haag</p>
        <p>070 – 887 3306</p>
        <p><a href="mailto:info@magicprint.nl" className="text-primary underline">info@magicprint.nl</a></p>
      </div>
    </div>
  </PageLayout>
);

export default Privacy;
